<div *ngIf="filtredElements$ | async as fields">
  <mat-list
    dense
    [cdkDropListData]="fields"
    cdkDropList
    id="default_fields_list_id">
    <ng-container *ngFor="let field of fields"> <!-- manque type dans FieldConfig -->
      <mat-list-item cdkDrag
                     class="dm__elements df_field">
        <mat-icon matListItemIcon>{{field.options.icon}}</mat-icon>
        <span>{{field.nom}}</span>
      </mat-list-item>
    </ng-container>
  </mat-list>
</div>
